import React from 'react'
import styled from 'styled-components'
import { Box } from 'rebass'
import { throttle } from 'lodash'
import { themePx } from '../styles/theme'

// TODO: Animate and fade in laces, when calculated

const Root = styled(Box)`
  position: relative;
  flex: 1 1 auto;
  transform: translate(${themePx('space.2')}, ${themePx('space.2')});

  svg {
    display: block;
    position: absolute;
    top: 0;
    left: 0;
  }
`

class Laces extends React.Component {
  constructor(props) {
    super(props);
    this.container = React.createRef();
    this.canvas = React.createRef();

    this.state = {
      width: 0,
      height: 0,
      viewBox: `0 0 1000 1000`,
      path: `M 0,0 C 0,1 1,1 2,2`
    }
  }
  
  componentDidMount() {
    setTimeout(() => {this.update()})
    if (window) {
      window.addEventListener('resize', (this.onResizeHandler = throttle(evt => this.onResize(evt),100)))
    }
  }

  componentWillUnmount() {
  }

  onResize(evt) {
    this.update()
  }

  update() {
    if (this.container && this.container.current) {
      const rect = this.container.current.getBoundingClientRect();
      
      if (rect) {
        const width = rect.width;
        const height = rect.height + 32;
    
        this.setState({
          width,
          height,
          viewBox: `0 0 ${width} ${height}`,
          path: `M 0,0 C 0,${height / 2} ${width},${height / 2} ${width - 1},${height - 1}`
        })
      }
    }
  }

  render () {
    const {viewBox, path, width, height} = this.state;

    return (
      <Root
        ref={this.container}
        {...this.props}>
        <svg
          ref={this.canvas}
          xmlns="http://www.w3.org/2000/svg"
          width={width}
          height={height}
          viewBox={viewBox}>
          <path
            d={path}
            stroke="#979797"
            strokeDasharray="8 2"
            fill="none" />
        </svg>
      </Root>
    )
  }
}

Laces.defaultProps = {
}

export default Laces
